var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginBgRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 631.318,
    height: 822.035,
    viewBox: "0 0 631.318 822.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right_pane_graphics",
    "data-name": "right pane graphics",
    transform: "translate(-734.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42351",
    "data-name": "Group 42351",
    transform: "translate(0 -60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124512",
    "data-name": "Path 124512",
    d: "M1011.455,732.111c5.147,0,5.156-8,0-8s-5.156,8,0,8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42352",
    "data-name": "Group 42352",
    transform: "translate(0 -60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124513",
    "data-name": "Path 124513",
    d: "M1204.532,725.643c2.574,0,2.578-4,0-4s-2.578,4,0,4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42353",
    "data-name": "Group 42353",
    transform: "translate(0 -60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124514",
    "data-name": "Path 124514",
    d: "M1150.723,882.035c2.574,0,2.578-4,0-4s-2.578,4,0,4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42355",
    "data-name": "Group 42355",
    transform: "translate(0 -60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124516",
    "data-name": "Path 124516",
    d: "M1310.839,280.143c4.505,0,4.512-7,0-7s-4.511,7,0,7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_124431",
    "data-name": "Path 124431",
    d: "M1121.842,144.6c37.3,43.38,82.761,80.827,111.61,129.929,27.12,46.159,37.7,99.465,48.779,151.524s23.638,105.27,53.9,149.543A185.946,185.946,0,0,0,1366,609.485V0H1063.759C1069.42,51.531,1093.687,111.856,1121.842,144.6Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124432",
    "data-name": "Path 124432",
    d: "M1178.318,433.065l5.541-2.477,1.1-5.969a.833.833,0,0,1,1.439-.407l4.068,4.505,6.018-.8a.834.834,0,0,1,.832,1.243l-3.027,5.261,2.617,5.476a.834.834,0,0,1-.925,1.176l-5.939-1.253-4.4,4.181a.834.834,0,0,1-1.4-.516l-.643-6.036-5.337-2.892A.834.834,0,0,1,1178.318,433.065Z",
    transform: "translate(0 -60)",
    fill: "#19a2dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124433",
    "data-name": "Path 124433",
    d: "M1216.759,499.125l4.433-1.982.882-4.775a.667.667,0,0,1,1.151-.326l3.254,3.6,4.814-.638a.668.668,0,0,1,.666.995l-2.422,4.209,2.094,4.381a.667.667,0,0,1-.74.941l-4.751-1-3.52,3.345a.667.667,0,0,1-1.123-.413l-.514-4.829-4.27-2.313A.667.667,0,0,1,1216.759,499.125Z",
    transform: "translate(0 -60)",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124436",
    "data-name": "Path 124436",
    d: "M1252.406,812.98a3.316,3.316,0,0,1-1.721-3.537L1252.748,798l-11.517-2.076a3.332,3.332,0,0,1,1.184-6.557l11.517,2.076L1256,780.01a3.33,3.33,0,0,1,3.869-2.689l.329.059a3.326,3.326,0,0,1,2.684,3.869l-2.064,11.438,11.517,2.076a3.332,3.332,0,0,1-1.184,6.558l-11.516-2.076-2.064,11.437a3.33,3.33,0,0,1-3.869,2.688l-.327-.059A3.3,3.3,0,0,1,1252.406,812.98Z",
    transform: "translate(0 -60)",
    fill: "#00a3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124507",
    "data-name": "Path 124507",
    d: "M971.324,800.519a12.783,12.783,0,0,0-15.67-9.492,18.816,18.816,0,0,0-22.624-9.994,23.178,23.178,0,0,0-41.632,4.049,15.9,15.9,0,0,0-23.629,13.894c0,.521.027,1.035.076,1.543Z",
    transform: "translate(0 -60)",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "VQhVNn.tif",
    transform: "translate(0 -60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42358",
    "data-name": "Group 42358",
    transform: "translate(0 61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124518",
    "data-name": "Path 124518",
    d: "M1198.646,177.534a2.452,2.452,0,0,1,3.1-.981c1.159.374,2.345.668,3.525.973a2.328,2.328,0,0,1,1.834,1.982c.522,2.693,1.068,5.381,1.6,8.072.033.164.074.328.135.594.686-1.124,1.325-2.165,1.958-3.209q5.764-9.493,11.515-18.995a2.556,2.556,0,0,1,2.437-1.387l15.318,4.2c.182.124.373.238.546.375a2.193,2.193,0,0,1-1.91,3.844c-1.082-.277-2.156-.586-3.233-.881l-9.495-2.6-.564-.154c-1.145,1.886-2.272,3.746-3.4,5.6q-6.126,10.094-12.254,20.186a2.226,2.226,0,0,1-2.411,1.191,2.25,2.25,0,0,1-1.768-1.917q-1.24-6.208-2.463-12.422a.709.709,0,0,0-.622-.673c-.621-.132-1.221-.361-1.843-.487a2.5,2.5,0,0,1-2.251-2.415Z",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124519",
    "data-name": "Path 124519",
    d: "M1232.191,191.748c.683,1.193,1.34,2.318,1.975,3.456a2.2,2.2,0,1,1-3.823,2.172c-.559-.967-1.107-1.939-1.662-2.909-.092-.162-.191-.319-.345-.574-.469.287-.913.571-1.369.836-.7.406-1.394.816-2.106,1.195a2.194,2.194,0,0,1-2.189-3.8c.984-.6,2-1.146,2.994-1.718.161-.092.317-.191.523-.316-.652-1.142-1.287-2.257-1.926-3.371a2.17,2.17,0,0,1-.12-2.164,2.1,2.1,0,0,1,1.89-1.224,2.071,2.071,0,0,1,1.972,1.082c.669,1.139,1.3,2.3,1.974,3.493.172-.082.309-.137.436-.209.942-.534,1.88-1.072,2.821-1.606a2.22,2.22,0,1,1,2.2,3.814C1234.379,190.507,1233.319,191.107,1232.191,191.748Z",
    fill: "#ff7f32"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28782",
    "data-name": "Rectangle 28782",
    width: 100,
    height: 18,
    transform: "translate(962 558)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42347",
    "data-name": "Group 42347",
    transform: "translate(0 -60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124508",
    "data-name": "Path 124508",
    d: "M736.614,541.25c2.573,0,2.578-4,0-4s-2.578,4,0,4Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBgRight);
export default __webpack_public_path__ + "static/media/Login-BgRight.5cc7b2afa65bc85ea1b46f49927dcb5f.svg";
export { ForwardRef as ReactComponent };